import apiClient from './apiClient'

export interface ModelExample {
  question: string
  dax: string
}

export interface CustomFields {
  description: string
  aliases: string[]
  use_when: string[]
  do_not_use_when: string[]
  query_instructions: string[]
  examples: ModelExample[]
}

export const emptyCustomFields = (): CustomFields => ({
  description: '',
  aliases: [],
  use_when: [],
  do_not_use_when: [],
  query_instructions: [],
  examples: [],
})

export interface SemanticModelRef {
  dataset_id: string
  name: string
  workspace_id: string
  is_implemented: boolean
}

export interface ImplementedModel {
  id: string
  dataset_id: string
  workspace_id: string
  name: string
  custom_fields: CustomFields
  markdown: string
  created_at: number
  created_by: string | null
  updated_at: number | null
  updated_by: string | null
}

export interface SaveModelRequest {
  dataset_id: string
  workspace_id: string
  name: string
  custom_fields: CustomFields
}

export const getAvailableModels = async (): Promise<SemanticModelRef[]> => {
  const response = await apiClient.get<SemanticModelRef[]>(
    '/semantic-models/available'
  )
  return response.data
}

export const getImplementedModels = async (): Promise<ImplementedModel[]> => {
  const response = await apiClient.get<ImplementedModel[]>(
    '/semantic-models/implemented'
  )
  return response.data
}

export const saveModel = async (
  request: SaveModelRequest
): Promise<ImplementedModel> => {
  const response = await apiClient.post<ImplementedModel>(
    '/semantic-models',
    request
  )
  return response.data
}

export const updateModel = async (
  datasetId: string,
  request: SaveModelRequest
): Promise<ImplementedModel> => {
  const response = await apiClient.put<ImplementedModel>(
    `/semantic-models/${datasetId}`,
    request
  )
  return response.data
}

export const deleteModel = async (datasetId: string): Promise<void> => {
  await apiClient.delete(`/semantic-models/${datasetId}`)
}
